import { render, staticRenderFns } from "./AccessGroupForm.vue?vue&type=template&id=dc496882"
import script from "./AccessGroupForm.vue?vue&type=script&lang=js"
export * from "./AccessGroupForm.vue?vue&type=script&lang=js"
import style0 from "./AccessGroupForm.vue?vue&type=style&index=0&id=dc496882&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/hive-platform-web/hive-platform-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dc496882')) {
      api.createRecord('dc496882', component.options)
    } else {
      api.reload('dc496882', component.options)
    }
    module.hot.accept("./AccessGroupForm.vue?vue&type=template&id=dc496882", function () {
      api.rerender('dc496882', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/AccessControl/AccessGroupForm.vue"
export default component.exports